<script setup lang="ts">
  import { UIAvatar, UIButton, UIPopover, UITextSmNormal } from '@gohighlevel/ghl-ui'
  import { useStore } from '@/utils/store'
  import { LogOut01Icon } from '@gohighlevel/ghl-icons/24/outline'
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'
  import { ref } from 'vue'
  import { orderedCacTabs } from '@/utils/cacTabs'

  const { t } = useI18n()
  const store = useStore()
  const router = useRouter()
  const tabs = orderedCacTabs()
  const menuOpen = ref(false)

  const goToStore = () => {
    window.open('/')
  }

  const setMenuOpen = (value: boolean) => {
    menuOpen.value = value
  }

  const goToTab = (route: string) => {
    menuOpen.value = false
    router.push(route)
  }
</script>
<template>
  <nav class="flex justify-between items-center flex-wrap gap-4">
    <div class="flex items-center gap-6">
      <span
        @click="goToStore()"
        class="font-semibold text-base cursor-pointer overflow-hidden whitespace-nowrap overflow-ellipsis max-w-32 lg:max-w-fit"
      >
        {{ store.storeName }}
      </span>

      <RouterLink
        v-for="tab in tabs"
        :key="tab.id"
        :to="tab.route"
        :id="`nav-tab-${tab.id}`"
        class="font-semibold text-base no-underline text-gray-950 lg:block hidden"
        active-class="!text-primary-700"
      >
        {{ t(tab.labelKey) }}
      </RouterLink>
    </div>
    <div class="flex items-center gap-4">
      <UIPopover
        v-if="store.token.value"
        :duration="undefined"
        placement="bottom-end"
        :showArrow="false"
        trigger="click"
        :show="menuOpen"
        :on-update-show="setMenuOpen"
      >
        <template #trigger>
          <UIButton :ghost="true" :circle="true" id="customSlotPopOver">
            <UIAvatar :src="undefined" :fallbackSrc="undefined">
              {{
                store.user.value.name
                  ?.split(' ')
                  .map(str => str[0])
                  .join('')
              }}
            </UIAvatar>
          </UIButton>
        </template>

        <template #header>
          <UITextSmNormal>{{ store.user.value.name }}</UITextSmNormal>
          <UITextSmNormal>{{ store.user.value.email }}</UITextSmNormal>
        </template>

        <UIButton
          v-for="tab in tabs"
          :key="tab.id"
          @click="goToTab(tab.route)"
          :linkGray="true"
          :text="true"
          :id="`${tab.id}-button`"
          class="mt-2 w-full text-left justify-start"
        >
          <component :is="tab.icon" class="w-4 h-4 mr-2" />
          {{ t(tab.labelKey) }}
        </UIButton>

        <div class="mt-2 border-t border-x-0 border-b-0 border-solid border-gray-200"></div>

        <UIButton @click="store.logout()" :linkGray="true" :text="true" id="logout-button" class="my-2 w-full text-left justify-start">
          <LogOut01Icon class="w-4 h-4 mr-2" />
          {{ t('nav.logout') }}
        </UIButton>
      </UIPopover>
      <UIButton type="primary" id="go-to-store-button" @click="goToStore()">{{ t('nav.goToStore') }}</UIButton>
    </div>
  </nav>
</template>
